import apiClient from './apiClient';
import { Search, CreateSearchParams, SearchListResponse, SearchListParams, FilterInterpretation } from '../types/search.types';

/**
 * Creates a new search with the specified search query and city ID
 * @param params Object containing search_query and city_id
 * @returns The created search object
 */
export const createSearch = async (params: CreateSearchParams): Promise<Search> => {
  const response = await apiClient.post('/searches/', params);
  return response.data;
};

export const interpretWebsiteFilter = async (
  businessType: string,
  description: string,
): Promise<FilterInterpretation> => {
  const response = await apiClient.post('/searches/website-filter/interpret', {
    business_type: businessType,
    description,
  });
  return response.data;
};

export const getSearches = async (params?: SearchListParams): Promise<SearchListResponse> => {
  const searchParams = new URLSearchParams();
  
  if (params?.page) {
    searchParams.append('page', params.page.toString());
  }
  if (params?.items_per_page) {
    searchParams.append('items_per_page', params.items_per_page.toString());
  }
  if (params?.status) {
    searchParams.append('status', params.status);
  }
  
  const url = `/searches/${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  const response = await apiClient.get(url);
  return response.data;
};

export const getSearch = async (id: number): Promise<Search> => {
  const response = await apiClient.get(`/searches/${id}`);
  return response.data;
};

export const deleteSearch = async (id: number): Promise<void> => {
  await apiClient.delete(`/searches/${id}`);
}; 
